/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NotificationRequest = {
    properties: {
        user_id: {
            type: 'number',
            isRequired: true,
        },
        title: {
            type: 'string',
            isRequired: true,
        },
        body: {
            type: 'string',
            isRequired: true,
        },
        data: {
            type: 'string',
            isRequired: true,
        },
        key: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
